const replacements: readonly [RegExp, string][] = [
  [/Матрица активирована/g, 'Поток активирован'],
  [/матрица активирована/g, 'поток активирован'],
  [/\bMatrices\b/g, 'Flows'],
  [/\bMatrix\b/g, 'Flow'],
  [/\bmatrices\b/gi, 'flows'],
  [/\bmatrix\b/gi, 'flow'],
  [/Матрицах/g, 'Потоках'],
  [/Матрицами/g, 'Потоками'],
  [/Матрицей/g, 'Потоком'],
  [/Матрице/g, 'Потоке'],
  [/Матрицу/g, 'Поток'],
  [/Матрицы/g, 'Потока'],
  [/Матрица/g, 'Поток'],
  [/Матриц/g, 'Потоков'],
  [/матрицах/g, 'потоках'],
  [/матрицами/g, 'потоками'],
  [/матрицей/g, 'потоком'],
  [/матрице/g, 'потоке'],
  [/матрицу/g, 'поток'],
  [/матрицы/g, 'потока'],
  [/матрица/g, 'поток'],
  [/матриц/g, 'потоков'],
]

/** Replaces the legacy backend term before it reaches the Gonka Game UI. */
export function formatFlowTerminology(text: string): string {
  // Backend copy can contain links: preserve URLs, but translate visible HTML attributes.
  const replaceWords = (value: string) => replacements.reduce(
    (result, [pattern, replacement]) => result.replace(pattern, replacement), value,
  )
  return text.split(/(<[^>]*>)/g).map(part => part.startsWith('<')
    ? part.replace(/\b(title|alt|aria-label)="([^"]*)"/g, (_, name: string, value: string) =>
      `${name}="${replaceWords(value)}"`)
    : replaceWords(part)
  ).join('')
}
